'use client';

import { CAPABILITIES, type Capability } from './capabilities';
import { useRuntime } from './RuntimeContext';

export function useCapability(cap: Capability): boolean {
  const runtime = useRuntime();
  return CAPABILITIES[runtime].has(cap);
}
